import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { posts } from '../data/posts';
export function Blog() {
  const preview = posts.slice(0, 2);
  return <section id="insights" className="insights sec" data-id="element-14">
      <div className="insights__in" data-id="element-15">
        <div className="sec__head" data-id="element-16">
          <div data-id="element-17">
            <div className="eyebrow mb-5" data-id="element-18">Insights</div>
            <h2 data-id="element-19">
              Thoughts on <span className="serif" data-id="element-20">design</span> & growth.
            </h2>
          </div>
          <Link to="/blog" className="ghost" data-id="element-21">
            View all insights
            <ArrowRight size={16} data-id="element-22" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12" data-id="element-23">
          {preview.map(article => <article key={article.slug} className="group flex flex-col border border-line rounded-r-lg p-7 md:p-8 bg-canvas h-full transition-colors hover:border-line-2" data-id="element-24">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-4 mono text-xs uppercase tracking-wider" data-id="element-25">
                <span className="text-lime" data-id="element-26">{article.category}</span>
                <span className="text-mut-2" data-id="element-27">•</span>
                <span className="text-mut-2" data-id="element-28">{article.date}</span>
                <span className="text-mut-2" data-id="element-29">•</span>
                <span className="text-mut-2" data-id="element-30">{article.readTime}</span>
              </div>
              <Link to={`/blog/${article.slug}`} className="block flex-1" data-id="element-31">
                <h3 className="text-2xl md:text-3xl font-bold mb-3 tracking-tight group-hover:text-lime transition-colors" data-id="element-32">
                  {article.title}
                </h3>
                <p className="text-mut text-base md:text-lg leading-relaxed" data-id="element-33">
                  {article.excerpt}
                </p>
              </Link>
              <Link to={`/blog/${article.slug}`} className="ghost mt-6 self-start" data-id="element-34">
                Read article
                <ArrowRight size={16} data-id="element-35" />
              </Link>
            </article>)}
        </div>
      </div>
    </section>;
}